var exports = {
  "DD": "LoginPage.module__title___WF9La3",
  "FE": "LoginPage.module__loginContainer___WF9La3",
  "eZ": "LoginPage.module__loginNotice___WF9La3",
  "Zd": "LoginPage.module__form___WF9La3",
  "aK": "LoginPage.module__formLinks___WF9La3",
  "nf": "LoginPage.module__link___WF9La3",
  "x": "LoginPage.module__ssoBlock___WF9La3",
  "Mm": "LoginPage.module__ssoPane___WF9La3",
  "ie": "LoginPage.module__ssoSubtitle___WF9La3",
  "gM": "LoginPage.module__ssoButtonLabel___WF9La3",
  "Sx": "LoginPage.module__ssoCallbackActions___WF9La3",
  "Sf": "LoginPage.module__ssoRetryButton___WF9La3",
  "Rl": "LoginPage.module__ssoBackButton___WF9La3",
  "uL": "LoginPage.module__ssoProcessingHint___WF9La3",
};

module.exports = exports;
